import store from '@/store'

export default function() {
  // ALWAYS 'me' in Conseil since you can only view your own data
  // Is used to display other user's data in Advisory
  let isAdvisor = store.getters['auth/isAdvisor']

  if (isAdvisor && store.state.user.profile) {
    return store.state.user.profile.id
  } else {
    return 'me'
  }
}
